/**
 * Extracts and merges roles from a decoded Keycloak JWT payload.
 *
 * Priority (SIMPL-30736):
 * 1. `client-roles` — canonical SIMPL claim, assigned via SIMPL-Open UI
 * 2. `realm_access.roles` — legacy fallback for backward compatibility
 *
 * Both sources are merged and deduplicated so users assigned via either
 * path (SIMPL-Open UI or Keycloak Admin directly) get correct access.
 */
export const extractRoles = (decoded: {
  "client-roles"?: string[];
  realm_access?: { roles?: string[] };
}): string[] => {
  const clientRoles = decoded["client-roles"] ?? [];
  const realmRoles = decoded.realm_access?.roles ?? [];
  return [...new Set([...clientRoles, ...realmRoles])];
};
